"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackingGA = void 0;
// @ts-nocheck
const trackingGA = () => {
    if (window.gaData && window.gtag) {
        Object.keys(window.gaData).forEach((gaId) => {
            let pagePath = '';
            if (window.location.hash) {
                const pathName = window.location.pathname.replace(/(\/index.html)(\S)*/i, '');
                const hashPath = window.location.hash.replace(/(#)/i, '');
                pagePath = `${pathName}${hashPath}`;
            }
            else {
                pagePath = window.location.pathname;
            }
            window.gtag('config', gaId, { page_path: pagePath });
        });
    }
};
exports.trackingGA = trackingGA;
//# sourceMappingURL=trackingGA.js.map